export const HABIT_COLORS = [
  '#6366F1', // Indigo
  '#8B5CF6', // Violet
  '#EC4899', // Pink
  '#EF4444', // Red
  '#F97316', // Orange
  '#EAB308', // Yellow
  '#22C55E', // Green
  '#14B8A6', // Teal
  '#06B6D4', // Cyan
  '#3B82F6', // Blue
];

export const HABIT_TEMPLATES = [
  { name: 'Drink water', icon: '💧', color: '#06B6D4', category: 'Health' },
  { name: 'Meditate', icon: '🧘', color: '#8B5CF6', category: 'Mindfulness' },
  { name: 'Exercise', icon: '💪', color: '#EF4444', category: 'Fitness' },
  { name: 'Read 20 pages', icon: '📖', color: '#3B82F6', category: 'Learning' },
  { name: 'Journal', icon: '📝', color: '#EAB308', category: 'Mindfulness' },
  { name: 'Walk 10,000 steps', icon: '🚶', color: '#22C55E', category: 'Fitness' },
  { name: 'No sugar', icon: '🍬', color: '#EC4899', category: 'Health' },
  { name: 'Sleep by 11pm', icon: '😴', color: '#6366F1', category: 'Health' },
  { name: 'Stretch', icon: '🤸', color: '#14B8A6', category: 'Fitness' },
  { name: 'Practice gratitude', icon: '🙏', color: '#F97316', category: 'Mindfulness' },
  { name: 'Cook a meal', icon: '🍳', color: '#EF4444', category: 'Health' },
  { name: 'No phone before bed', icon: '📱', color: '#8B5CF6', category: 'Health' },
  { name: 'Learn a language', icon: '🗣️', color: '#3B82F6', category: 'Learning' },
  { name: 'Practice instrument', icon: '🎵', color: '#EC4899', category: 'Creative' },
  { name: 'Take vitamins', icon: '💊', color: '#22C55E', category: 'Health' },
  { name: 'Floss teeth', icon: '🦷', color: '#06B6D4', category: 'Health' },
  { name: '10 push-ups', icon: '🏋️', color: '#EF4444', category: 'Fitness' },
  { name: 'No caffeine after 2pm', icon: '☕', color: '#F97316', category: 'Health' },
  { name: 'Write code', icon: '💻', color: '#6366F1', category: 'Learning' },
  { name: 'Tidy workspace', icon: '🧹', color: '#14B8A6', category: 'Productivity' },
  { name: 'Deep breathing', icon: '🌬️', color: '#8B5CF6', category: 'Mindfulness' },
  { name: 'Drink green tea', icon: '🍵', color: '#22C55E', category: 'Health' },
];

export const MILESTONES = [
  { days: 7, label: '1 Week', emoji: '🔥' },
  { days: 14, label: '2 Weeks', emoji: '🔥🔥' },
  { days: 21, label: '3 Weeks', emoji: '🌟' },
  { days: 30, label: '1 Month', emoji: '⭐' },
  { days: 50, label: '50 Days', emoji: '🏆' },
  { days: 100, label: '100 Days', emoji: '💎' },
  { days: 200, label: '200 Days', emoji: '👑' },
  { days: 365, label: '1 Year', emoji: '🎯' },
];

export const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const FREE_HABIT_LIMIT = 3;

export const STREAK_FREEZE_MONTHLY_LIMIT = 3;

export const PREMIUM_FEATURES = {
  unlimitedHabits: {
    name: 'Unlimited Habits',
    description: 'Track as many habits as you want',
  },
  streakFreeze: {
    name: 'Streak Freeze',
    description: 'Protect your streaks when life gets busy',
  },
  advancedAnalytics: {
    name: 'Advanced Analytics',
    description: 'Detailed charts and completion trends',
  },
  dataExport: {
    name: 'Data Export',
    description: 'Export your data as CSV or JSON',
  },
  customIcons: {
    name: 'Custom Icons',
    description: 'Personalize your habits with custom icons',
  },
};
